const appendLocaleSuffixToPath = (path, locale) => path.replace(/^\//, `/${locale}/`);

export default appendLocaleSuffixToPath;
